module.exports = __webpack_public_path__ + "static/media/circle_green.8a629bfe.png";